import { ApiBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';
import { ScmIntegrationsApi, scmIntegrationsApiRef, ScmAuth } from '@backstage/integration-react';
import { configApiRef, createApiFactory } from '@backstage/core-plugin-api';

/**
 * Provides the SCM Integrations API backed by app-config.yaml.
 */
const scmIntegrationsApiExtension = ApiBlueprint.make({
    name: 'scm-integrations',
    params: defineParams =>
        defineParams(
            createApiFactory({
                api: scmIntegrationsApiRef,
                deps: { configApi: configApiRef },
                factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
            }),
        ),
});

/**
 * Provides the default SCM Auth API (handles git credential helpers etc.).
 */
const scmAuthApiExtension = ApiBlueprint.make({
    name: 'scm-auth',
    params: defineParams => defineParams(ScmAuth.createDefaultApiFactory()),
});

/**
 * Frontend module that registers custom API factories as native New Frontend
 * System extensions, replacing the `apis` array previously passed to
 * `convertLegacyAppOptions`.
 */
export const apisModule = createFrontendModule({
    pluginId: 'app',
    extensions: [scmIntegrationsApiExtension, scmAuthApiExtension],
});


